import React from 'react';
import { CheckIcon, PickaxeIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { Countdown } from './ui/Countdown';
import { checkoutUrl, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
const assurances = ['7-day guarantee', 'Secure payment', 'Instant access', 'Teach mining and mineral resources with confidence starting today'];
export function FinalCta() {
  return <section className="bg-forest-900 py-16 sm:py-20" aria-labelledby="final-title" data-id="element-74" data-mp="1jbaj0hj66o3h">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-75" data-mp="1edinzen8alv2">
        <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[.16em] text-gold-400" data-id="element-76" data-mp="1t3g4r9itw9a8">
          <PickaxeIcon className="h-4 w-4" aria-hidden="true" data-id="element-77" data-mp="1o4wjlbc271ix" /> {productShortName}
        </p>
        <h2 id="final-title" className="mx-auto mt-5 max-w-2xl text-balance text-3xl font-extrabold text-cream sm:text-4xl" data-id="element-78" data-mp="222uychuakzyy">
          Created by mining education specialists, for educators worldwide
        </h2>

        <Countdown className="mt-8" data-id="element-79" data-mp="n6w7h09dnscq" />

        <div className="mt-8 flex flex-col gap-5 rounded-xl bg-cream p-6 text-left shadow-2xl shadow-black/30 sm:flex-row sm:items-center sm:justify-between" data-id="element-80" data-mp="n7yx74uyror2">
          <p data-id="element-81" data-mp="x2z9850bhoz5">
            <b className="block text-sm uppercase leading-tight text-forest-900" data-id="element-82" data-mp="x27esxighxag">{productShortName}</b>
            <span className="text-sm text-muted" data-id="element-83" data-mp="1246fu0qq4i48">
              {totalVolumes} volumes + {totalBonuses} bonuses · Instant access
            </span>
          </p>
          <div className="shrink-0 sm:text-right" data-id="element-84" data-mp="1b2rtpil938yo">
            <p className="text-sm text-muted" data-id="element-85" data-mp="1b1gqpkzmq58m">
              <span className="mr-2 line-through" data-id="element-86" data-mp="1fu05umdyt8fj">{priceBefore}</span>
              <b className="text-base text-forest-800" data-id="element-87" data-mp="1ktd0htb2vjso">{price}</b>
            </p>
            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" size="sm" className="mt-2" data-id="element-88" data-mp="1kvftmm7j1t1m">
              Get my teacher ready now
            </Button>
          </div>
        </div>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-forest-100" data-id="element-89" data-mp="1tryerc9iocnn">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-90" data-mp="3lwne49louude">
              <CheckIcon className="h-4 w-4 text-gold-400" aria-hidden="true" data-id="element-91" data-mp="3hcv1m7ejl4l" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}